export default {
  snackbar (context, { active, color, timeout, text, actionText, action }) {
    let snackbar = Object.assign({}, context.snackbar)
    if (color) snackbar.color = color
    if (timeout) snackbar.timeout = (timeout === 0 ? -1 : timeout)
    else if (color === 'error') snackbar.timeout = 10000
    else if (color === 'success') snackbar.timeout = 6000
    if (text) snackbar.text = text
    if (actionText) snackbar.actionText = actionText
    if (action) snackbar.action = action
    // This should equate to a true or false exactly; using !! will turn something that evaluates to true/false but is not actually true/false into a true/false
    snackbar.active = (active == null ? true : !!active)

    context.commit('setSnackbar', snackbar)
  }
}
